module.exports = __webpack_public_path__ + "media/images/about_kansai_recommended_guide_hero-1e3b3b0badea5024d8179aee9c5966e4.png";